import { render, staticRenderFns } from "./EmailActivation.vue?vue&type=template&id=5f37643b&scoped=true"
import script from "./EmailActivation.vue?vue&type=script&lang=js"
export * from "./EmailActivation.vue?vue&type=script&lang=js"
import style0 from "./EmailActivation.vue?vue&type=style&index=0&id=5f37643b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f37643b",
  null
  
)

export default component.exports